<template>
  <div class="question-sets-block">
    <vx-card title="Questions Sets" class="mb-6">
      <div class="question-set pb-4" v-for="(item, index) in ((questionSets || {}).items || [])" :key="index">
        <hr />
        <div class="flex mt-3">
          <div class="flex-grow">
            <h5 class="mt-1">{{item.name}}</h5>
            <div class="pl-6 pt-2 flex" v-for="(qitem, qindex) in item.questionSetItems" :key="qindex"> {{ qindex + 1 }}. <div class="pl-3" v-html="qitem.question.question"></div></div>
          </div>
          <div class="flex">
            <div class="ml-2 inline">
              <vs-tooltip text="Edit">
                <vs-button @click="$router.push(`/questions/${item.id}`)" type="filled" icon-pack="feather" icon="icon icon-edit"></vs-button>
                <span>&nbsp;</span>
              </vs-tooltip>
            </div>
            <div class="ml-2 inline">
              <vs-tooltip text="Delete" >
                <vs-button type="border" @click="deleteQuestionSetById(item.id)" color="danger" icon-pack="feather" icon="icon icon-trash"></vs-button>
                <span>&nbsp;</span>
              </vs-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="question-set pb-4 mt-2" v-if="newQuestionSet">
        <hr />
        <div class="flex mt-5">
          <div class="flex-grow">
            <vx-field ref="newQuestionSetField" type="input" v-validate="'required'" placeholder="Name" v-model="form.name" as="name" />
          </div>
          <div class="flex">
            <div class="ml-2 inline">
              <vs-tooltip text="Save" >
                <vs-button @click="submitNewQuestionSet" color="success" type="filled" icon-pack="feather" icon="icon icon-check"></vs-button>
                <span>&nbsp;</span>
              </vs-tooltip>
            </div>
            <div class="ml-2 inline">
              <vs-tooltip text="Cancel" >
                <vs-button @click="cancelNewQuestionSet" color="danger" type="border" icon-pack="feather" icon="icon icon-x" />
                <span>&nbsp;</span>
              </vs-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div v-if="questionSets && (!questionSets.items || (questionSets.items && questionSets.items.length === 0)) && !newQuestionSet"> No Question Set Created</div>
      <vs-button v-show="!newQuestionSet" class=" mt-6" @click="startNewQuestionSet" icon-pack="feather" icon="icon-plus" icon-before> Add New Question Set </vs-button>
    </vx-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import orderBy from 'lodash/orderBy';
export default {
  data () {
    return {
      newQuestionSet: false,
      form: {
        name: ''
      }
    }
  },
  computed: {
    ...mapState('visitManagement', {
      questionSets: state => {
        return {
          ...state.questionSets,
          items: (state.questionSets.items || []).map(item => {
            return {
              ...item,
              questionSetItems: orderBy(item.questionSetItems || [], 'sortOrder')
            }
          })
        }
      }
    })
  },
  methods: {
    ...mapActions('visitManagement', ['deleteQuestionSetById']),
    submitNewQuestionSet () {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.$store.dispatch('visitManagement/updateQuestionSet', { data: this.form })
            .then(questionSet => {
              this.$router.push(`/questions/${questionSet.id}`);
            });
        }
      })
    },
    cancelNewQuestionSet () {
      this.newQuestionSet = false;
      this.form.name = '';
      this.$nextTick(this.$removeTooltips)
    },
    startNewQuestionSet () {
      this.newQuestionSet = true;
      this.$nextTick(() => {
        const { newQuestionSetField } = this.$refs;
        if (newQuestionSetField) {
          const { vsInput } = newQuestionSetField.$refs;
          if (vsInput) vsInput.focusInput();
        }
      });
    }
  },
  async created () {
    await this.$store.dispatch('visitManagement/fetchQuestionSets', { limit: 200 });
  }
}
</script>